module.exports = __webpack_public_path__ + "img/japan_map.895fe66e.png";